namespace SP.Data {
    export class ReturnShipment {

        static async getReturnShipmentInfo(trackingNumber: string) {
            var response = await SP.get<any>("/api/v1/info/returnShipmentInfo/" + trackingNumber);

            if (response.status == 200) {
                return response.data as ReturnOrderInfo;
            }
            else {
                await SP.alertX(response.status + ": " + response.msg);
            }

            return null;
        }


        static async getReturnShipmentInfoByOrderId(orderId: number) {
            var response = await SP.get<any>("/api/v1/info/returnShipmentInfoByOrderId/" + orderId);

            if (response.status == 200) {
                return response.data as ReturnOrderInfo;
            }
            else {
                await SP.alertX(response.status + ": " + response.msg);
            }

            return null;
        }


        static async getShipmentInfo(shipmentId: string) {
            var response = await SP.get<any>("/api/v1/info/shipmentInfo/" + shipmentId);

            if (response.status == 200) {
                return response.data as ShipmentInfo;
            }
            else {
                await SP.alertX(response.status + ": " + response.msg);
            }

            return null;
        }


        static async createReturnShipment(id: string, warehouseActionId: string, warehouseReasonId: string) {
            var response = await SP.get<any>(`/api/v1/shipment/createReturnShipmentFast?id=${id}&warehouseActionId=${warehouseActionId}&warehouseReasonId=${warehouseReasonId}`);

            if (response.status == 200) {
                return response.data;
            }
            else {
                await SP.alertX(response.status + ": " + response.msg);
            }

            return response;
        }


        static async finishReturnShipment(postData: any) {
            var response = await SP.post<any>(`/api/v1/returnShipment/updateAndFinish`, postData);

            if (response.status == 200) {
                return response;
            }
            else {
                await SP.alertX(response.status + ": " + response.msg);
            }

            return response;
        }


        static async searchOrderShipmentInfos(postData: any) {
            const response = await SP.post<any>(`/api/v1/info/searchOrderInfosShipments`, postData);

            if (response.status != 200)
                await SP.alertX(response.msg);

            return response.data as ReturnOrderInfo[];
        }


        static async cancelReturnShipment(shipmentId: string) {
            var response = await SP.get<any>("/api/v1/returnshipment/cancel/" + shipmentId);

            if (response.status == 200) {
                return response.status;
            }
            else {
                await SP.alertX(response.status + ": " + response.msg);
            }

            return null;
        }
    }
}